import ViewMode from '@/javascripts/editor/view_mode';

export function initViewMode(): void {
  const viewMode = new ViewMode();
  viewMode.replace();
}
